import React from 'react';

import { BulkDownloadDocumentsView } from './BulkDownloadDocumentsView';

export const BulkDownloadAdminDocumentsView: React.FC = () => {
  return (
    <BulkDownloadDocumentsView
      withProjectAttachments={true}
      withContracts={true}
      withAttachmentsTypes={true}
    />
  );
};
